import React from 'react';

const checkmarkIcon = React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M3.33203 11.5L7.14155 15.8333L16.6654 5", stroke: "#62DD13", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));

export { checkmarkIcon };
//# sourceMappingURL=checkmark_icon.js.map
